import { Marker, MarkerContent } from "@/components/ui/marker";
import {
	type TurnContinuationReason,
	turnContinuationLabel,
} from "../../../../email-assistant/core/turnContinuations";

export function TurnContinuationMarker({
	reason,
}: {
	reason: TurnContinuationReason;
}) {
	return (
		<div className="w-full px-4 py-3">
			<Marker variant="separator">
				<MarkerContent>{turnContinuationLabel(reason)}</MarkerContent>
			</Marker>
		</div>
	);
}
